// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import TranscriptCodeContainer from './TranscriptCodeContainer'
import ChatCodeContainer from 'chat/ChatCodeContainer';
import {
  Switch,
  Route,
} from 'react-router-dom'

function QualRightSideBar(props) {
  const getCodeContainer = (CodeContainer, otherProps = {}) => {
    return (routeProps) => {
        return (
          <CodeContainer
            projectID={props.projectID}
            transcriptID={props.transcriptID}
            {...routeProps}
            {...otherProps}
          />
        );
    }
  }

  if ( !props.hasEditPermission )
    return <h3></h3>

  return (
    <div style={{height:"100%"}}>
        <Switch>
          <Route
            path='/projects/:projectID/analysis'
            render={getCodeContainer(ChatCodeContainer)}
            />
          <Route
            path='/projects/:projectID/chat'
            render={getCodeContainer(ChatCodeContainer)}
          />
          <Route
            path='/projects/:projectID/search'
            render={() => <h3></h3>}
            />
          <Route
            path='/projects/:projectID'
            render={() => <h3></h3>}
            />
          <Route
            path='/projects/:projectID/transcripts/new'
            render={() => <h3></h3>}
            />
          <Route
            path='/transcripts/:transcriptID/demographics'
            render={() => <div></div>}
          />
          <Route
            path='/users/'
            render={() => <h3></h3>}
          />
          <Route
            path='/transcripts/:transcriptID/edit'
            render={() => <h3></h3>}
          />
          <Route
            path='/transcripts/:transcriptID/user/me'
            render={getCodeContainer(TranscriptCodeContainer, {
              hideCodeCounts: true
            })}
          />
          <Route
            path='/transcripts/:transcriptID'
            render={getCodeContainer(TranscriptCodeContainer)}
          />
          <Route
            path='/survey_responses/:surveyResponseID'
            render={getCodeContainer(TranscriptCodeContainer)}
          />
          <Route
            path='/survey_questions/:surveyQuestionID'
            render={getCodeContainer(TranscriptCodeContainer)}
          />
        </Switch>
    </div>
  );
}

export default QualRightSideBar;
